<template>
    <div style="margin: 10px">
        <v-card>
            <v-card-text>
                <table class="lstTable">
                    <tr>
                        <th>Nhóm vật tư</th>
                        <th>Mã vật tư</th>
                        <th>Tên vật tư</th>
                        <th>Đơn vị</th>
                        <th>Số lượng</th>
                        <th >Thành tiền</th>
                    </tr>
                    <template v-for="(value,name) in lstData" v-if="value != undefined">
                        <tr v-for="(item,index) in value.items">
                            <td :rowspan="value.row" v-if="index==0">{{value.categoryName}}</td>
                            <td>{{item.materialCode}}</td>
                            <td>{{item.materialName}}</td>
                            <td>{{item.unit}}</td>
                            <td style="text-align: right">{{item.quantity | currency}}</td>
                            <td style="text-align: right">{{item.amount | currency}}</td>
                        </tr>
                    </template>
                </table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "../../shared/message";
    import moment from "moment";

    export default {
        name: "material-report-item",
        components: {},
        props: {
            crop: {
                type: Object,
                default: () => {
                    return null;
                },
            },
            search: {
                type: Object,
                default: () => {
                    return null;
                },
            },

        },

        watch: {
            search: {
                handler(value) {
                    this.getExportData();
                },
                deep: true
            }
        },

        data: () => {
            return {
                lstExport:[],
                lstData:[],
                lstMaterialType:[],
            };
        },

        created() {
            this.getMaterialType();
            this.getExportData();
        },

        methods: {
            getMaterialType() {
                //let url = process.env.VUE_APP_API_URL + "/category/listByTypeAndCode?type=MATERIAL_TYPE&code=VTN";
                let url = process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE";

                axios.post(url).then(
                    (data) => {
                        if (data.length > 0) {
                            this.lstMaterialType = data;
                        }
                    }
                );
            },

            getExportData() {
                let report = {
                    areaId: this.search.areaId,
                    cropId: this.crop.cropId,
                    statusList: [5,6], // trang thai da xuat 1 phan hoac xuat het
                    toDate: this.search.toDate,
                    fromDate: this.search.fromDate,
                    assetsNameId: this.search.assetsNameId,
                }
                axios.post(process.env.VUE_APP_API_URL + "/exportRequest/materialSearchReport?page=-1&pageSize=-1", report).then(
                    data => {
                        this.lstExport = data.items;
                        for (let i = 0; i < this.lstExport.length; i++) {
                            this.lstExport[i].data = JSON.parse(this.lstExport[i].requestData);
                        }
                        this.calculateData();
                    }
                )
            },

            calculateData(){
                this.lstData = [];
                console.log(this.lstMaterialType);
                console.log("lstExport", this.lstExport);
                let mtData = {};

                for(let i=0;i<this.lstExport.length;i++){
                    for(let j=0;j<this.lstExport[i].data.length;j++){
                        if(this.lstExport[i].data[j].materialId != undefined && this.lstExport[i].data[j].materialId != null){
                            if(mtData[this.lstExport[i].data[j].materialId] == undefined || mtData[this.lstExport[i].data[j].materialId] == null){
                                mtData[this.lstExport[i].data[j].materialId] = Object.assign({},this.lstExport[i].data[j]);
                                mtData[this.lstExport[i].data[j].materialId].quantity = parseFloat(this.lstExport[i].data[j].total_export);
                                mtData[this.lstExport[i].data[j].materialId].amount = parseFloat(this.lstExport[i].data[j].amount);
                            } else {
                                mtData[this.lstExport[i].data[j].materialId].quantity += parseFloat(this.lstExport[i].data[j].total_export);
                                mtData[this.lstExport[i].data[j].materialId].amount += parseFloat(this.lstExport[i].data[j].amount);
                            }
                        }
                    }
                }

                for(let key in mtData){
                    let typeId = mtData[key].typeId;
                    if(this.lstData[typeId] == undefined ||   this.lstData[typeId] == null){
                        this.lstData[typeId] = this.lstMaterialType.filter( item =>{
                            return item.categoryId == typeId;
                        })[0];
                        this.lstData[typeId].row = 1;
                        this.lstData[typeId].items = [mtData[key]];
                    } else {
                        this.lstData[typeId].items.push(mtData[key]);
                        this.lstData[typeId].row = this.lstData[typeId].items.length;
                    }
                }
                this.$emit("update", {
                    crop: this.crop,
                    data: this.lstData
                });
                this.$forceUpdate();

            },

        },

        destroyed() {
        },
    };
</script>

<style>
    .indicator {
        margin: 5px 5px 5px 0px;
        padding: 5px;
        display: inline-block;
        border: 1px solid gray;
        width: fit-content;
    }

    .G2 {
        background-color: gold;
    }

    .G3 {
        background-color: crimson;
    }
</style>